/*
 * Link Atom Component
 *
 */

import React from "react"
import PropTypes from "prop-types"
import Icon from "../icon/icon"
import { Link } from "gatsby"

const AllyLink = props => {
  return (
    <>
      {props.linkType === "--internal" ? (
        <Link
          className={`link link--internal link${props.modifier} ${props.className}`}
          to={props.to}
        >
          <span className="link__text">{props.text}</span>
          <span className="sr-only">{props.srOnly}</span>

          {props.icon ? (
            <Icon
              name={props.icon}
              title={props.iconTitle}
              modifier={props.iconModifier}
            />
          ) : (
            <></>
          )}
        </Link>
      ) : (
        <>
          {props.linkType === "--external" ? (
            <a
              className={`link link--external link${props.modifier} ${props.className}`}
              rel="noreferrer"
              target="_blank"
              href={props.to}
            >
              <span className="sr-only">{props.srOnly}</span>
              <span className="link__text">{props.text}</span>

              {/* Added in CSS with ::after */}
              {/* <Icon name="open-in-new" title="open in new tab" /> */}
            </a>
          ) : (
            <>
              {props.linkType === "--email" ? (
                <>
                  {props.to ? (
                    <a
                      className={`link link--email link${props.modifier} ${props.className}`}
                      rel="noreferrer"
                      target="_blank"
                      href={`mailto:${props.to}`}
                    >
                      <Icon name="mail" title="email" />

                      <span className="link__text">{props.text}</span>
                      <span className="sr-only">{props.srOnly}</span>
                    </a>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {props.linkType === "--social" ? (
                    <>
                      {props.to ? (
                        <a
                          id={props.icon}
                          className={`link link--social link${props.modifier} ${props.className}`}
                          rel="noreferrer"
                          target="_blank"
                          href={`https://${props.socialURL}/${props.to}`}
                        >
                          <Icon
                            modifier="--social-icons"
                            name={props.icon}
                            title={props.iconTitle}
                          />
                          <span className="sr-only">{props.srOnly}</span>
                        </a>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <>
                      <p>
                        Error: No `linkType` value. Please select a link type in
                        Storyblok.
                      </p>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}

AllyLink.defaultProps = {
  linkType: "--internal",
  text: "Link text",
  className: "",
  srOnly: "",
  icon: "",
  iconTitle: "",
  iconModifier: "",
  to: "/",
  modifier: "",
}

AllyLink.propTypes = {
  linkType: PropTypes.oneOf([
    "--internal",
    "--external",
    "--email",
    "--social",
  ]),
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  srOnly: PropTypes.string,
  to: PropTypes.string.isRequired,
  icon: PropTypes.oneOf([
    "",
    "chevron",
    "social-instagram",
    "social-linkedin",
    "social-researchgate",
    "social-website",
    "social-x",
    "social-youtube",
  ]),
  iconTitle: PropTypes.string,
  iconModifier: PropTypes.oneOf(["", "--small", "--x-small"]),
  modifier: PropTypes.oneOf([
    "",
    "--menu-item",
    "--legal-link",
    "--filter-by-button",
    // "--back-button",
    "--magenta-button",
    "--marine-button",
    "--small",
    "--contact-us-link",
  ]),
}

export default AllyLink
